import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PRIMARY_OUTLET, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';

export class CustomValidators {

  static personalId(onlyEgn?): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } | null => {
      if (onlyEgn) {
        return (control.value != null && control.value != '') && this.isValidPin(control.value) ?
          null : { personalId: control.value };
      }
      return ((control.value != null && control.value != '') && (this.isValidPin(control.value) || this.isValidEIK(`${ control.value }`))) ?
        null : { personalId: control.value };
    };
  }

  static isValidEIK(v) {
    let matches;
    if (!(matches = v.match(/^(BG)?((\d{9})(\d{4})?)$/))) {
      return false;
    }

    // 1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
    let a = matches[3];
    let a9 = a[0] * 1 + a[1] * 2 + a[2] * 3 + a[3] * 4 + a[4] * 5 + a[5] * 6 + a[6] * 7 + a[7] * 8;
    a9 = a9 % 11;

    // tslint:disable-next-line:triple-equals
    if (a9 == 10) {
      // 3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
      a9 = a[0] * 3 + a[1] * 4 + a[2] * 5 + a[3] * 6 + a[4] * 7 + a[5] * 8 + a[6] * 9 + a[7] * 10;
      a9 = a9 % 11;
    }

    // tslint:disable-next-line:triple-equals
    a9 = a9 == 10 ? 0 : a9;

    // tslint:disable-next-line:triple-equals
    if (a9 != a[8]) {
      return false;
    }
    if (!matches[4]) {
      return true;
    }

    // 2*а9 + 7*а10 + 3*а11 +5*а12
    a = matches[4];
    let a13 = a9 * 2 + a[0] * 7 + a[1] * 3 + a[2] * 5;
    a13 = a13 % 11;

    // 4*а9+9*а10+5*а11+7*а12
    // tslint:disable-next-line:triple-equals
    if (a13 == 10) {
      a13 = a9 * 4 + a[0] * 9 + a[1] * 5 + a[2] * 7;
      a13 = a13 % 11;
    }

    // tslint:disable-next-line:triple-equals
    a13 = a13 == 10 ? 0 : a13;

    // tslint:disable-next-line:triple-equals
    return (a13 == a[3]);
  }

  static isValidPin(pin) {
    const inFuture = (d) => (d.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0));
    // @ts-ignore
    const isValidDate = (d) => (d instanceof Date && !isNaN(d));
    const pinStr = pin.toString();
    let result = false;

    if (pinStr.length === 10) {
      const pinWeights = [2, 4, 8, 5, 10, 9, 7, 3, 6];
      const year = parseInt(pinStr.substr(0, 2), 10);
      const month = parseInt(pinStr.substr(2, 2), 10);
      const day = parseInt(pinStr.substr(4, 2), 10);

      const date = (month > 40) ?
        new Date(year + 2000, month - 41, day) :
        month > 20 ?
          new Date(year + 1800, month - 21, day) :
          new Date(year + 1900, month - 1, day);
      if (isValidDate(date) && !inFuture(date)) {
        const checksum = parseInt(pinStr.substr(9, 1), 10);
        let pinsum = 0;

        for (let i = 0;i < 9;i++) {
          pinsum += parseInt((pinStr.substr(i, 1) * pinWeights[i]).toString(), 10);
        }

        let validChecksum = pinsum % 11;
        // tslint:disable-next-line:triple-equals
        if (validChecksum == 10) {
          validChecksum = 0;
        }

        result = (checksum === validChecksum) ? true : false;
      }
    }
    return result;
  }
}
